import { Input, InputInfoMsg } from "components/common/input/Input";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import './SignUpStep2.css'
import { ResRegInput } from "components/common/input/ResRegInput";
import { useAtom } from "jotai";
import { stepAtom } from "store/signUpStore";
import { Button } from "components/common/button/Button";
import { SelectBox, SelectBoxItem, SelectBoxRef } from "components/common/selectBox/SelectBox";
import { Device } from "common/device";

export const SignUpStep2 = () => {
    const {t} = useTranslation();
    const carriers = [
        {name: t("signUp.skt"), value: "SKT"},
        {name: t("signUp.ktf"), value: "KTF"},
        {name: t("signUp.lgt"), value: "LGT"},
        {name: t("signUp.skm"), value: "SKM"},
        {name: t("signUp.ktm"), value: "KTM"},
        {name: t("signUp.lgm"), value: "LGM"},
    ]

    
    const [step, setStep] = useAtom(stepAtom);
    const [sideStep, setSideStep] = useState(1);
    
    const [btnName, setBtnName] = useState(t("signUp.btnNext"));

    // input value
    const [nameVal, setNameVal] = useState("");
    const [resRegFrontVal, setResRegFrontVal] = useState("");
    const [resRegBackVal, setResRegBackVal] = useState("");
    const [telecomValue, setTelecomValue] = useState<SelectBoxItem>();
    const [phoneValue, setPhoneValue] = useState("");

    // input Ref
    const nameRef = useRef<HTMLInputElement>(null);
    const resRegFrontRef = useRef<HTMLInputElement>(null);
    const resRegBackRef = useRef<HTMLInputElement>(null);
    const telecomRef = useRef<HTMLInputElement>(null);
    const telecomSelRef = useRef<SelectBoxRef>(null);

    // input 안내 메시지
    const [nameInfoMsg, setNameInfoMsg] = useState<InputInfoMsg | undefined>(undefined);
    const [resRegInfoMsg, setResRegInfoMsg] = useState<InputInfoMsg | undefined>(undefined);
    const [telecomInfoMsg, setTelecomInfoMsg] = useState<InputInfoMsg | undefined>(undefined);
    const [phoneInfoMsg, setPhoneInfoMsg] = useState<InputInfoMsg | undefined>(undefined);

    // 유효 여부
    const [isNameValid, setIsNameValid] = useState(false);
    const [isResRegValid, setIsResRegValid] = useState(false);
    const [isTelecomValid, setIsTelecomValid] = useState(false);
    const [isPhoneValid, setIsPhoneValid] = useState(false);
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);

    const onNext = useCallback(() => {
        if(sideStep === 1) {
            setSideStep(2);
        } else if(sideStep === 2) {
            setSideStep(3);
            setBtnName(t("signUp.btnSMS"));
        } else if(sideStep === 3) {
            setStep(3);
        }
    },[sideStep, setStep, t])

    // const onValidCheck = () => {
    //     const isNameValid = nameVal.trim().length > 0;
    //     const isResRegValid = resRegFrontVal.trim().length === 6 && resRegBackVal.trim().length === 1;

    //     setResRegInfoMsg(!isResRegValid ? {
    //         msg: t("signUp.resRegErrorMsg"),
    //         type: "error"
    //     } : undefined);
    //     setNameInfoMsg(!isNameValid ? {
    //         msg: t("signUp.nameErrorMsg"),
    //         type: "error"
    //     } : undefined);

    //     // 이름 주민번호 입력단계
    //     if(sideStep === 1) {
    //         // Valid통과 : 다음스텝
    //         if(isNameValid && isResRegValid) {
    //             setSideStep(2);
    //         }
    //         return;
    //     }

    //     const isTelecomValid = telecomValue !== undefined;
    //     setTelecomInfoMsg(!isTelecomValid ? {
    //         msg: t("signUp.telecomErrorMsg"),
    //         type: "error"
    //     } : undefined);

    //     // 이름 주민번호 통신사 입력단계
    //     if(sideStep === 2) {
    //         // Valid통과 : 다음스텝
    //         if(isNameValid && isResRegValid && isTelecomValid) {
    //             setSideStep(3);
    //             setBtnName(t("signUp.btnSMS"))
    //         }
    //         return;
    //     }

    //     const isPhoneValid = phoneValue.trim().length >= 11;
    //     setPhoneInfoMsg(!isPhoneValid ? {
    //         msg: t("signUp.phoneErrorMsg"),
    //         type: "error"
    //     } : undefined);

    //     // 이름 주민번호 통신사 전화번호 입력단계
    //     if(sideStep === 3) {
    //         // Valid통과 : 다음스텝
    //         if(isPhoneValid) setStep(3);
    //         return;
    //     }
    // }

    useEffect(() => {
        if(sideStep === 1) {
            setIsBtnDisabled(!isNameValid || !isResRegValid);
        } else if(sideStep === 2) {
            setIsBtnDisabled(!isNameValid || !isResRegValid || !isTelecomValid);
        } else if(sideStep === 3) {
            setIsBtnDisabled(!isNameValid || !isResRegValid || !isTelecomValid || !isPhoneValid);
        }
    },[sideStep, isNameValid, isResRegValid, isTelecomValid, isPhoneValid])

    // 이름 유효성 검사
    useEffect(() => {
        if(nameVal.trim().length === 0) {
            setIsNameValid(false);
            setNameInfoMsg(undefined);
            return;
        }
        const isValid = nameVal.trim().length > 0;
        setIsNameValid(isValid);
        setNameInfoMsg(!isValid ? {
            msg: t("signUp.nameErrorMsg"),
            type: "error"
        } : undefined);
    },[nameVal, t])

    useEffect(() => {
        if(resRegFrontVal.trim().length === 0 && resRegBackVal.trim().length === 0) {
            setIsResRegValid(false);
            setResRegInfoMsg(undefined);
            return;
        }
        const isValid = resRegFrontVal.trim().length === 6 && resRegBackVal.trim().length === 1;
        setIsResRegValid(isValid);
        setResRegInfoMsg(!isValid ? {
            msg: t("signUp.resRegErrorMsg"),
            type: "error"
        } : undefined);
    },[resRegFrontVal, resRegBackVal, t])

    useEffect(() => {
        if(telecomValue === undefined) {
            setIsTelecomValid(false);
            setTelecomInfoMsg(undefined);
        } else {
            setIsTelecomValid(true);
            setTelecomInfoMsg(undefined);
        }
    },[telecomValue, t])

    useEffect(() => {
        if(phoneValue.trim().length === 0) {
            setIsPhoneValid(false);
            setPhoneInfoMsg(undefined);
            return;
        }
        const isValid = phoneValue.trim().length >= 11;
        setIsPhoneValid(isValid);
        setPhoneInfoMsg(!isValid ? {
            msg: t("signUp.phoneErrorMsg"),
            type: "error"
        } : undefined);
    },[phoneValue, t])

    return (
        <div className="sign-up-step-2" style={{display: step === 2 ? "block" : "none"}}>
            <div className={`sign-up-hide-container ${sideStep >= 3 ? "" : "hide"}`}>
                <Input
                    id="phone"
                    inputVal={phoneValue}
                    onChange={(e) => {
                        setPhoneValue(e.target.value.replace(/[^0-9]/g, ''));
                    }}
                    type="tel"
                    title={t("signUp.phone")}
                    placeholder={t("signUp.phonePlaceHolder")}
                    infoMsg={phoneInfoMsg}
                />
            </div>
            <div className={`sign-up-hide-container ${sideStep >= 2 ? "" : "hide"}`}>
                <Input
                    id="telecom"
                    inputVal={telecomValue?.name || ""}
                    title={t("signUp.telecom")}
                    readOnly
                    placeholder={t("signUp.telecomPlaceHolder")}
                    ref={telecomRef}
                    onClick={() => {telecomSelRef.current?.open()} }
                    infoMsg={telecomInfoMsg}
                />
                <SelectBox
                    items={carriers}
                    ref={telecomSelRef}
                    selectedItem={telecomValue}
                    onSelect={(item) => {
                        setTelecomValue(item);
                        telecomSelRef.current?.close();
                    }}
                />
            </div>
            
            <Input
                id="name"
                ref={nameRef}
                inputVal={nameVal}
                setInputVal={setNameVal}
                title={t("signUp.name")}
                placeholder={t("signUp.namePlaceHolder")}
                infoMsg={nameInfoMsg}
            />
            
            <ResRegInput
                frontVal={resRegFrontVal}
                backVal={resRegBackVal}
                setFrontVal={setResRegFrontVal}
                setBackVal={setResRegBackVal}
                frontRef={resRegFrontRef}
                backRef={resRegBackRef}
                infoMsg={resRegInfoMsg}
            />

            <div style={{position: 'fixed', bottom: Device.inset.navigationBarHeight, width: '100%', left: 0, padding: "0 20px 20px"}}>
                <Button
                    text={btnName}
                    onPress={onNext}
                    disabled={isBtnDisabled}
                />
            </div>
        </div>

    )
}